export default `
<div ng-bind-html="$ctrl.staticPage.content | trustAsHtml"></div>
`;
